// extracted by mini-css-extract-plugin
export default {"container":"styles_container__o+WW8","spinner":"styles_spinner__vAxYn"};